import React, { useEffect, useState } from "react";
import QuestionTabs from "./QuestionTabs";
import api from "../../seller-apis/api";
import { fetchunansQA } from "../../seller-apis/apidataField";
import PaginationNew from "../common/Pagination";
import SubmitAnswerModal from "../common/SubmitAnswerModal";
import { useDispatch } from "react-redux";
import { Actions } from "../../Actions/Actions";
import { useAlert } from "react-alert";
import MainLoader from "../common/Loader/PageLoader";
var filterData = {};
function PendingQuestions(props) {
  const dispatch = useDispatch();
  const [answQ, setanswQ] = useState([]);
  const [totalrecords, setTotalRecords] = useState();
  const [selectedPage, setSelectedPage] = useState(1);
  const [selectedData, setSelectedData] = useState(null);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(true);
  const alert = useAlert();
  const handleClose = () => {
    setShow(false);
  };
  useEffect(() => {
    filterData = {
      pageNo: "1",
      type: "NEW",
    };
    getQA(filterData);
  }, []);
  const pendingDatafunc=(data)=>{
    // setanswQ(data)
  }
  function getQA(data = filterData, updateAction = null) {
    setLoading(true);
    api.QandA.fetchQA(fetchunansQA(data)).then((res) => {
      // console.log(res);
      if(updateAction==='action'){ console.log("datagsiu"); Actions.upadteQuesCount(dispatch, res.totalRecords);}
      setanswQ([...res.data]);
      setTotalRecords(res.totalRecords);
      setLoading(false);
    });
  }
  const ignoreQuestion = (qId) => {
    let postdata = {
      questionId: qId,
    };
    // console.log(postdata);
    api.QandA.ignoreQuestions(postdata).then((res) => {
      alert.info("Question Ignored");
      getQA(filterData, "action");
      // console.log(res);
    });
  };
  function paginate(data) {
    filterData = {
      pageNo: data.number,
      type: "NEW",
    };
    getQA(filterData);
    setSelectedPage(data.number);
  }
  const refreshData = () => {
    getQA(filterData, "action");
  };
  // function detailnew(url) {
  //   let data =
  //   {
  //     "filter": { "urlKey": url }
  //   }
  //   servicesApi.getProductDetail(data).then((res) => {
  //     props.pdetail([res.data], props.price)

  //     props.popupdetailVis("2");
  //   }).catch(err => console.log(err))

  // }

  if (loading) {
    return (
      <div className="question_loading_box">
        <div>
          <MainLoader />
        </div>
      </div>
    )
  }
  else{
  return (
    <>
      <div className="question-container table-responsive">
        <table className="w-100 new-table-design pt-2">
          <tr>
            <th>Image</th>
            <th style={{ width: "30%" }}>Product</th>
            <th style={{ width: "30%" }}>Question</th>
            <th style={{ width: "16%" }}>Action</th>
          </tr>
          {answQ.length > 0 &&
            answQ.map((item, index) => {
              // let baseImg = "";
              // item.productId.images.map((item) => {
              //   if (item.baseImage === true) {
              //     if (item.image.startsWith("products")) {
              //       baseImg = item.image;
              //     } else {
              //       let img = item.image.substr("41");
              //       baseImg = img;
              //     }
              //   }
              // });
              return (
                <tr>
                  <td>
                    <div className="border-x">
                      <img
                        src={
                          "https://s3.toolsvilla.com/" +
                          item.productId.images[0].image
                        }
                        className="col3"
                      ></img>
                    </div>
                  </td>
                  <td>
                    <div className=" text-left border-x px-2">
                      <div className="product-name text-left w-100 mt-1">
                        {item.productId.productName}
                      </div>
                      <div className="question-sku-but">
                        <div className="sku w-100">
                          SKU : {item.productId.SKU}
                        </div>
                        <a
                          href={`/productDetail/${item.productId._id}/approv`}
                          target="_blank"
                          // onClick={() => detailnew(props.url)}
                          className="detail-but"
                        >
                          <button className="px-1 order_table_btn_details">
                            Details
                          </button>
                        </a>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div className=" text-left border-x question">
                      {item.question}
                    </div>
                  </td>
                  <td>
                    <div className="border-x">
                      <button
                        className="ques-action-button icon-but mb-1"
                        onClick={() => {
                          setSelectedData(item);
                          setShow(true);
                        }}
                      >
                        {" "}
                        <img src="/edit-line.webp" /> Answer This Question
                      </button>
                      <button
                        className="ques-ignore-but text-center"
                        onClick={() => {
                          ignoreQuestion(item._id);
                        }}
                      >
                        Ignore This Question
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
        </table>
        <PaginationNew
          number={totalrecords}
          paginate={paginate}
          activ={selectedPage}
          comp={"pending"}
        />
        {show ? (
          <SubmitAnswerModal
            data={selectedData}
            show={show}
            handleClose={handleClose}
            refreshData={refreshData}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
}
}

export default PendingQuestions;
